const OTP_RESEND_COOLDOWN_SECONDS = 60;

export const ACTIONS = {
  TICK_TIMER: 'TICK_TIMER',
  SET_OTP_VALUE: 'SET_OTP_VALUE',
  SET_IS_TRUE_VALUE: 'SET_IS_TRUE_VALUE',
  VERIFY_ERROR: 'VERIFY_ERROR',
  RESET_VERIFY_UI: 'RESET_VERIFY_UI',
  RESEND_START: 'RESEND_START',
  RESEND_SUCCESS: 'RESEND_SUCCESS',
  RESEND_ERROR: 'RESEND_ERROR',
};

export const INITIAL_STATE = {
  otpLastValue: '',
  errorMessage: '',
  isFalseValue: false,
  isTrueValue: false,
  isReset: false,
  timeLeft: OTP_RESEND_COOLDOWN_SECONDS,
  recaptchError: false,
};
export const initialState = INITIAL_STATE;

export function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ACTIONS.TICK_TIMER:
      return {
        ...state,
        timeLeft: Math.max(0, Number(state.timeLeft || 0) - 1),
      };
    case ACTIONS.SET_OTP_VALUE:
      return {
        ...state,
        otpLastValue: String(action.payload ?? ''),
        errorMessage: '',
        isFalseValue: false,
        isTrueValue: false,
      };
    case ACTIONS.SET_IS_TRUE_VALUE:
      return {
        ...state,
        isTrueValue: Boolean(action.payload),
        isFalseValue: false,
      };
    case ACTIONS.VERIFY_ERROR:
      return {
        ...state,
        errorMessage: action.payload ?? '',
        isFalseValue: true,
        isTrueValue: false,
      };
    case ACTIONS.RESET_VERIFY_UI:
      return {
        ...state,
        errorMessage: '',
        isFalseValue: false,
        isTrueValue: false,
      };
    case ACTIONS.RESEND_START:
      return {
        ...state,
        isReset: false,
        recaptchError: false,
        errorMessage: '',
      };
    case ACTIONS.RESEND_SUCCESS:
      return {
        ...state,
        isReset: true,
        timeLeft: OTP_RESEND_COOLDOWN_SECONDS,
        recaptchError: false,
        errorMessage: '',
        isFalseValue: false,
      };
    case ACTIONS.RESEND_ERROR:
      return {
        ...state,
        isReset: false,
        recaptchError: Boolean(action.payload?.recaptchaError),
        errorMessage: action.payload?.errorMessage ?? '',
      };
    default:
      return state;
  }
}
